import React, { useMemo } from 'react';
import * as S from './loading-placeholder.styles';
export const LoadingPlaceholder = ({ square, circle, empty, className, size = 'small', width, }) => {
    // Random width is used when no width is provided. This is put in a memo to not created
    // different widths during rerenders.
    const randomWidth = useMemo(() => {
        return Math.floor(Math.random() * 5 + 4) * 10;
    }, []);
    return (React.createElement(S.Placeholder, { "data-testid": "loading-placeholder", className: className, square: square, circle: circle, empty: empty, size: size, width: width || randomWidth }));
};
//# sourceMappingURL=loading-placeholder.js.map